// extracted by extract-css-chunks-webpack-plugin
module.exports = {"video_box":"video_box-ycWJ0-VQ","video":"video-2t7COvwI"};